import { Component, EventEmitter, Injector, Input, Output, ViewChild } from '@angular/core';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { MedicinalproductsService } from '../../../service/medicinalproducts-service/medicinalproducts.service';
import { ItemFinderComponent } from '../../item-finder/item-finder.component';
import { MedicinalProductsListView } from '../../../ui/Data/MedicinalProductData/MedicinalProductsListView';
import { SimpleSearchListNode } from '../../../ui/Node/SimpleSearchListNode';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { FormlyView } from '../../../ui/Data/FormlyView';
import { ListView } from '../../../ui/Data/ListView';
import { QueryConditionsNode } from '../../../ui/Node/QueryConditionsNode';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';
import { TreeNodeDrugIngredientEntity } from '../../../ui/Node/MedicinalProductsNode/Entity/TreeNodeDrugIngredientEntity';


@Component({
  selector: 'app-detailed-medicinal-product-view',
  templateUrl: './detailed-medicinal-product-view.component.html',
  styleUrl: './detailed-medicinal-product-view.component.scss'
})
export class DetailedMedicinalProductViewComponent {
   constructor(private injector:Injector){
     this.injector.get(MedicinalproductsService).loading.subscribe(value=>this.loading=value);
   }
 
   @Input() selectedNode: any;
   @Output() modelChange = new EventEmitter<any>();
   @Output() selectedNodeChange = new EventEmitter<any>();
   @Output() buttonAction = new EventEmitter<any>();
   @Output() removeNode = new EventEmitter<any>();
   @ViewChild('item_finder_component') item_finder_component!: ItemFinderComponent; 
  
   loading:boolean=false;
 
  onFormlyDetailedModelChange(event: any) {

    this.modelChange.emit(event);
  }

  onListDetailedModelChange(event: any) {
    this.modelChange.emit(event);
  } 

  onButtonAction(event: any) {
    if (event.action == 'refreshMedicinalProducts') {
      this.item_finder_component.item_finder_search_component.refresh(
        MedicinalproductsService
      );
    } else {
      this.buttonAction.emit(event);
    }
  }

 onSelectedNodeChange(selectedNode:Art57Node){
  this.selectedNodeChange.emit(selectedNode);
 }

 onRemoveNode(selectedNode: Art57Node) {
  this.removeNode.emit(selectedNode);
 }

  isQueryListView(): boolean {
    return (this.selectedNode instanceof QueryResultNode) 
    || (this.selectedNode.data instanceof MedicinalProductsListView)
    || (this.selectedNode instanceof SimpleSearchListNode);
  }  

  isInstanceOfFormlyView(): boolean {
    return (this.selectedNode.data instanceof FormlyView) && (!this.isInstanceOfFormlyDrugIngredientsFormlyView());
  }

  isInstanceOfFormlyDrugIngredientsFormlyView(): boolean {
    return (this.selectedNode instanceof TreeNodeDrugIngredientEntity);
  }

  isInstanceOfListView(): boolean {
      return this.selectedNode.data instanceof ListView ||
             this.selectedNode instanceof ResultList;
    }
  
    isQueryNode(){
      return (this.selectedNode instanceof QueryResultNode) ||
      (this.selectedNode instanceof QueryConditionsNode);
  
    }
  

}
